// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__suUQc","select":"Header_select__1NAga","clinic":"Header_clinic__1RNVk"};